<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">
				<b-field label="タイトル"
					horizontal
					custom-class="require"
					:type="{ 'is-danger': $utils.hasError(errors, 'title') }"
					:message="errors.title">
					<b-input type="text" v-model="title" />
				</b-field>

				<b-field label="内容"
					horizontal>
					<b-input type="textarea" v-model="body" />
				</b-field>

				<b-field label="画像" horizontal>
					<div>
						<image-picker class="mb-10" :previewUrl="image" :isLoading="isImageLoading" :previewW="previewW" @file-change="onImageChange" @delete="onImageDelete"></image-picker>
					</div>
				</b-field>

				<b-field label="表示開始日時" horizontal>
					<date-picker :dateProvided="startDate" :hasError="$utils.hasError(errors, 'startDate')" @input="onStartDateInput"></date-picker>
 				</b-field>

 				<b-field label=""
 					horizontal
 					:type="{ 'is-danger': $utils.hasError(errors, 'startDate') }"
 					:message="errors.startDate">
					<time-select :timeProvided="startTime" :hasEmptyOption="true" @change="onStartTimeChange"></time-select>
 				</b-field>

				<b-field label="表示終了日時" horizontal>
					<date-picker :dateProvided="endDate" :hasError="$utils.hasError(errors, 'endDate')" @input="onEndDateInput"></date-picker>
 				</b-field>

 				<b-field label=""
 					horizontal
 					:type="{ 'is-danger': $utils.hasError(errors, 'endDate') }"
 					:message="errors.endDate">
					<time-select :timeProvided="endTime" :hasEmptyOption="true" @change="onEndTimeChange"></time-select>
 				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">{{ !id ? '登録' : '更新' }}</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.preview {
	height: auto;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import TimeSelect from '@/components/TimeSelect'
//import moment from 'moment-timezone'
import moment from 'moment'

export default {
	name: 'InformationEdit',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		TimeSelect,
	},
	data () {
		return {
			id: '',
			title: '',
			image: '',
			imageBase: '',
			body: '',
			startDate: '',
			startTime: '',
			endDate: '',
			endTime: '',
			errors: {
				title: '',
				startDate: '',
				endDate: '',
			},
			isLoading: false,
			isImageLoading: false,
			previewW: 200,
		}
	},
	computed: {
		titleStack () {
			return [
				'お知らせ登録',
			]
		},
		startDateTime: function() {
			if (this.startDate === '' && this.startTime ==='') {
				return '';
			}
			return this.startDate + ' ' + this.startTime;
		},
		endDateTime: function() {
			if (this.endDate === '' && this.endTime ==='') {
				return '';
			}
			return this.endDate + ' ' + this.endTime;
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		onEndTimeChange: function(time) {
			this.endTime = time;
		},
		onEndDateInput: function(date) {
			this.endDate = date;
		},
		onStartTimeChange: function(time) {
			this.startTime = time;
		},
		onStartDateInput: function(date) {
			this.startDate = date;
		},
		onImageDelete: function() {
			this.image = '';
		},
		onImageChange: function(file) {
			this.uploadImage(file);
		},
		uploadImage: async function(file, key) {
			this.isImageLoading = true;

			let data = {
				"image": file,
			};
			let ep = 'informations/image';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.image = res.data.url;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"title": this.title,
				"body": this.body,
				"image": this.image,
				"start_date": this.startDateTime,
				"end_date": this.endDateTime,
			};

			this.$utils.log(data);

			try {
				let ep = 'informations';
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess('データを更新しました');
				this.$router.push({ name: 'information' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.informationId ? '/' + this.$route.params.informationId: '';
			let ep = 'informations/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.title = res.data.title;
				this.image = res.data.image;
				this.imageBase = res.data.image_base;
				this.body = res.data.body;
				this.startDate = res.data.start_date;
				this.endDate = res.data.end_date;
				this.startTime = res.data.start_time;
				this.endTime = res.data.end_time;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
